import React, { useEffect, useRef, useState } from "react";
import { CSVReader } from "react-papaparse";
import { VariableSizeList } from 'react-window';

import { CustomTitleLabel } from "./CustomBaseComponments";
import AuthButton from "components/base/AuthButton";
import BasePrompt from "components/base/prompt/BasePrompt";
import PromptButton, { BUTTON_TYPES } from "components/base/prompt/BaseButtons";
import BaseSearchBar from "components/base/BaseSearchBar";

import { removeElementFromArray } from "utils";
import "./SkuImport.scss"
import { useFormContext } from "react-hook-form";
import { formatDate } from "utils/TimeFormatUtil";

const SkuImport = () => {
  const importButtonRef = useRef();
  const { watch, setValue } = useFormContext();

  const skuField = "inputSkus";
  const importTimeField = "skuFileImportTime";
  
  const fileImportedTime = watch(importTimeField);
  const setFileImportTime = (value) => {
    setValue(importTimeField, value, {shouldDirty: true})
  }
  const importedSkus = watch(skuField) || [];
  const setImportedSkus = (value) => {
    setValue(skuField, value, { shouldDirty: true })
  }
  const [showImportedSkuPrompt, setShowImportedSkuPrompt] = useState(false);
  const [skuSearch, setSkuSearch] = useState();
  const [skuSearchResult, setSkuSearchResult] = useState([]);

  const displaySkus = skuSearch ? skuSearchResult : importedSkus;

  const openImportFileDialog = (e) => {
    if (importButtonRef.current) {
      importButtonRef.current.open(e);
    }
  }
  const handleOnFileLoad = (data) => {
    let currentImportedSkus = [];
    data.map((element) => {
      const hasValueData = removeElementFromArray(element.data, '');
      if (hasValueData.length > 0) {
        currentImportedSkus = [...currentImportedSkus, ...hasValueData];
      }
      return undefined
    });
    setImportedSkus(currentImportedSkus);
    setFileImportTime(new Date());
  };

  const handleOnError = (err, file, inputElem, reason) => {
    console.log("@error", err);
  };

  const handleOnRemoveFile = (data) => {
    console.log("@removeFile", data);
  };

  const searchSku = (searchKey) => {
    return importedSkus.filter(sku => sku.indexOf(searchKey) !== -1)
  }

  useEffect(() => {
    if (!skuSearch) {
      setSkuSearchResult([])
      return
    }
    setSkuSearchResult(searchSku(skuSearch))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skuSearch])

  const sizeCache = useRef(new Map());
  const listRef = useRef();

  const getItemSize = (index) => {
    return sizeCache.current.get(index) || 50;
  };

  const VariableSizeListRow = ({ index, style }) => {
    const rowRef = useRef();

    useEffect(() => {
      if (rowRef.current) {
        const height = rowRef.current.clientHeight;
        if (height !== sizeCache.current.get(index)) {
          sizeCache.current.set(index, height);
          listRef.current.resetAfterIndex(index);
        }
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <div style={style}>
        <div ref={rowRef}>{displaySkus[index]}</div>
      </div>
    );
  };


  const skuPromptContent = () => {
    return (
      <>
        <div className="d-flex flex-column flex-gap-24 imported-sku-prompt-content">
          <div>
            <CustomTitleLabel title={'Imported time'} className={"create-section-label-no-top-space"} />
            <div className="tips-message">
              {fileImportedTime && formatDate(
                fileImportedTime,
                'DD MMM yyyy (ddd), HH:mm:ss A',
              )}
            </div>
          </div>
          <BaseSearchBar
            searchPlaceholder="Search sku"
            value={skuSearch}
            setValue={(value) => {
              setSkuSearch(value)
            }}
          />
          <div className="d-flex flex-column flex-gap-12">
            <CustomTitleLabel title={'SKU'} className={"create-section-label-no-top-space"} />
              <VariableSizeList
                ref={listRef}
                height={300}
                itemCount={displaySkus.length}
                itemSize={getItemSize} 
              >
              {VariableSizeListRow}
            </VariableSizeList>
          </div>
        </div>
        <div className="d-flex flex-gap-8" style={{justifyContent: "flex-end"}}>
          <PromptButton
            title={"Done"}
            action={() => { setShowImportedSkuPrompt(false) }}
            type={BUTTON_TYPES.main}
          />
        </div>
      </>
    )
  }

  return <>
    <div className="d-flex flex-gap-8">
      {fileImportedTime &&
        <AuthButton
          customClass="btn-back-button-common btn-download"
          title="View imported file"
          action={() => {
            setShowImportedSkuPrompt(true);
          }}
        />
      }
      <CSVReader
        ref={importButtonRef}
        onFileLoad={handleOnFileLoad}
        onError={handleOnError}
        noClick
        noDrag
        onRemoveFile={handleOnRemoveFile}
      >
        {({ file }) => (
          <div>
            <AuthButton
              customClass="btn-back-button-common btn-download"
              title={fileImportedTime ? "Replace current file" : "Import"}
              action={openImportFileDialog}
            />
          </div>
        )}
      </CSVReader>
    </div>

    <BasePrompt
      customClass={'imported-sku-prompt'}
      show={showImportedSkuPrompt}
      title={"Imported file"}
      closeAction={() => { setShowImportedSkuPrompt(false) }}
      otherBody={skuPromptContent}
    />
  </>
}

export default SkuImport;